import BeanieImg2 from "../images/image/products/accessories/beanie-black-2.png";
import BeanieImg from "../images/image/products/accessories/beanie-black.png";
import BeanieWhiteImg2 from "../images/image/products/accessories/beanie-white-2.png";
import BeanieWhiteImg from "../images/image/products/accessories/beanie-white.png";
import AureliaCoat2 from "../images/image/products/coat/aurelia/aurelia-coat-2.webp";
import AureliaCoat3 from "../images/image/products/coat/aurelia/aurelia-coat-3.webp";
import AureliaCoat4 from "../images/image/products/coat/aurelia/aurelia-coat-4.webp";
import AureliaCoat5 from "../images/image/products/coat/aurelia/aurelia-coat-5.webp";
import AureliaCoat6 from "../images/image/products/coat/aurelia/aurelia-coat-6.webp";
import AureliaCoat from "../images/image/products/coat/aurelia/aurelia-coat.webp";
import CelestineCoat2 from "../images/image/products/coat/celestine/celestine-coat-2.webp";
import CelestineCoat3 from "../images/image/products/coat/celestine/celestine-coat-3.webp";
import CelestineCoat4 from "../images/image/products/coat/celestine/celestine-coat-4.webp";
import CelestineCoat5 from "../images/image/products/coat/celestine/celestine-coat-5.webp";
import CelestineCoat6 from "../images/image/products/coat/celestine/celestine-coat-6.webp";
import CelestineCoat from "../images/image/products/coat/celestine/celestine-coat.webp";
import EmberJacket2 from "../images/image/products/coat/ember/ember-jacket-2.webp";
import EmberJacket3 from "../images/image/products/coat/ember/ember-jacket-3.webp";
import EmberJacket4 from "../images/image/products/coat/ember/ember-jacket-4.webp";
import EmberJacket5 from "../images/image/products/coat/ember/ember-jacket-5.webp";
import EmberJacket6 from "../images/image/products/coat/ember/ember-jacket-6.webp";
import EmberJacket from "../images/image/products/coat/ember/ember-jacket.webp";
import GraphiteJacket2 from "../images/image/products/coat/graphite/granite-jacket-2.webp";
import GraphiteJacket3 from "../images/image/products/coat/graphite/granite-jacket-3.webp";
import GraphiteJacket4 from "../images/image/products/coat/graphite/granite-jacket-4.webp";
import GraphiteJacket from "../images/image/products/coat/graphite/granite-jacket.webp";
import HorizonJacket2 from "../images/image/products/coat/horizon/horizon-jacket-2.webp";
import HorizonJacket3 from "../images/image/products/coat/horizon/horizon-jacket-3.webp";
import HorizonJacket4 from "../images/image/products/coat/horizon/horizon-jacket-4.webp";
import HorizonJacket5 from "../images/image/products/coat/horizon/horizon-jacket-5.webp";
import HorizonJacket6 from "../images/image/products/coat/horizon/horizon-jacket-6.webp";
import HorizonJacket from "../images/image/products/coat/horizon/horizon-jacket.webp";
import ObsidianCoat2 from "../images/image/products/coat/obsidian/obsidian-coat-2.webp";
import ObsidianCoat3 from "../images/image/products/coat/obsidian/obsidian-coat-3.webp";
import ObsidianCoat4 from "../images/image/products/coat/obsidian/obsidian-coat-4.webp";
import ObsidianCoat5 from "../images/image/products/coat/obsidian/obsidian-coat-5.webp";
import ObsidianCoat6 from "../images/image/products/coat/obsidian/obsidian-coat-6.webp";
import ObsidianCoat from "../images/image/products/coat/obsidian/obsidian-coat.webp";
import VermillionJacket2 from "../images/image/products/coat/vermillion/vermillion-jacket-2.webp";
import VermillionJacket3 from "../images/image/products/coat/vermillion/vermillion-jacket-3.webp";
import VermillionJacket4 from "../images/image/products/coat/vermillion/vermillion-jacket-4.webp";
import VermillionJacket from "../images/image/products/coat/vermillion/vermillion-jacket.webp";
import GlovesBrown2 from "../images/image/products/gloves/gloves-brown-2.webp";
import GlovesBrown from "../images/image/products/gloves/gloves-brown.webp";
import GlovesWhite2 from "../images/image/products/gloves/gloves-white-2.webp";
import GlovesWhite from "../images/image/products/gloves/gloves-white.webp";
import RobeBlue2 from "../images/image/products/robe/robe-blue-2.webp";
import RobeBlue3 from "../images/image/products/robe/robe-blue-3.webp";
import RobeBlue4 from "../images/image/products/robe/robe-blue-4.webp";
import RobeBlue from "../images/image/products/robe/robe-blue.webp";
import RobeOrange2 from "../images/image/products/robe/robe-orange-2.webp";
import RobeOrange3 from "../images/image/products/robe/robe-orange-3.webp";
import RobeOrange4 from "../images/image/products/robe/robe-orange-4.webp";
import RobeOrange from "../images/image/products/robe/robe-orange.webp";
import BlueShawl2 from "../images/image/products/shawl/blue/blue-shawl-2.webp";
import BlueShawl3 from "../images/image/products/shawl/blue/blue-shawl-3.webp";
import BlueShawl from "../images/image/products/shawl/blue/blue-shawl.webp";
import BrownShawl2 from "../images/image/products/shawl/brown/brown-shawl-2.webp";
import BrownShawl3 from "../images/image/products/shawl/brown/brown-shawl-3.webp";
import BrownShawl from "../images/image/products/shawl/brown/brown-shawl.webp";
import PinkShawl2 from "../images/image/products/shawl/pink/pink-shawl-2.webp";
import PinkShawl3 from "../images/image/products/shawl/pink/pink-shawl-3.webp";
import PinkShawl from "../images/image/products/shawl/pink/pink-shawl.webp";
import YellowShawl2 from "../images/image/products/shawl/yellow/yellow-shawl-2.webp";
import YellowShawl3 from "../images/image/products/shawl/yellow/yellow-shawl-3.webp";
import YellowShawl from "../images/image/products/shawl/yellow/yellow-shawl.webp";
import AlbaTurtleneck2 from "../images/image/products/sweater/alba/alba-turtleneck-2.webp";
import AlbaTurtleneck3 from "../images/image/products/sweater/alba/alba-turtleneck-3.webp";
import AlbaTurtleneck4 from "../images/image/products/sweater/alba/alba-turtleneck-4.webp";
import AlbaTurtleneck from "../images/image/products/sweater/alba/alba-turtleneck.webp";
import LumenTurtleneck2 from "../images/image/products/sweater/lumen/lumen-turtleneck-2.webp";
import LumenTurtleneck3 from "../images/image/products/sweater/lumen/lumen-turtleneck-3.webp";
import LumenTurtleneck4 from "../images/image/products/sweater/lumen/lumen-turtleneck-4.webp";
import LumenTurtleneck from "../images/image/products/sweater/lumen/lumen-turtleneck.webp";
import MistPullover2 from "../images/image/products/sweater/mist/mist-pullover-2.webp";
import MistPullover3 from "../images/image/products/sweater/mist/mist-pullover-3.webp";
import MistPullover4 from "../images/image/products/sweater/mist/mist-pullover-4.webp";
import MistPullover from "../images/image/products/sweater/mist/mist-pullover.webp";
import SandstonePullover2 from "../images/image/products/sweater/sandstone/sandstone-pullover-2.webp";
import SandstonePullover3 from "../images/image/products/sweater/sandstone/sandstone-pullover-3.webp";
import SandstonePullover4 from "../images/image/products/sweater/sandstone/sandstone-pullover-4.webp";
import SandstonePullover from "../images/image/products/sweater/sandstone/sandstone-pullover.webp";
import ValenceSweater2 from "../images/image/products/sweater/valence/valence-sweater-2.webp";
import ValenceSweater3 from "../images/image/products/sweater/valence/valence-sweater-3.webp";
import ValenceSweater4 from "../images/image/products/sweater/valence/valence-sweater-4.webp";
import ValenceSweater from "../images/image/products/sweater/valence/valence-sweater.webp";
import BeigeTrousers2 from "../images/image/products/trousers/beige-trousers-2.webp";
import BeigeTrousers3 from "../images/image/products/trousers/beige-trousers-3.webp";
import BeigeTrousers from "../images/image/products/trousers/beige-trousers.webp";
import GrayTrousers2 from "../images/image/products/trousers/gray-trousers-2.webp";
import GrayTrousers3 from "../images/image/products/trousers/gray-trousers-3.webp";
import GrayTrousers from "../images/image/products/trousers/gray-trousers.webp";

const products = [
  {
    slug: "graphite-jacket",
    name: "Graphite Jacket",
    price: "-",
    category: "coatAndJackets",
    description:
      "A 4-pocket coat crafted from 100% sheep wool in a deep greyish-black shade. Dense and substantial in feel, the pure wool construction provides exceptional warmth and reliable insulation against the cold. The structured silhouette is designed to sit firmly on the body, offering both protection and refined presence. Finished with functional pockets and a timeless cut, this heavy wool coat is ideal for winter wear in the city or countryside, combining durability, comfort, and understated sophistication.",
    material: "100% Sheep Wool",
    variants: [
      {
        color: "#212020",
        colorLabel: "Graphite",
        size: ["S", "M", "L"],
        image: [
          GraphiteJacket,
          GraphiteJacket2,
          GraphiteJacket3,
          GraphiteJacket4,
        ],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Notch lapel collar
        Single-breasted front
        Button fastening
        Four front patch pockets with buttoned flaps
        Chest patch pockets
        Lower patch pockets
        Structured shoulders
        Buttoned cuffs
        Clean, tailored silhouette
        Regular fit
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `Composition: 100% sheep wool
        
        Care: Eco dry clean only.
        
        This product should be handled with care. We suggest never wearing the product two days in a row, so that the fibres regain their natural structure and texture. Check the label for washing and ironing instructions. Use a professional cleaning service, particularly if your product includes delicate details. Fold carefully and store with cedar balls/moth repellent in a dry place away from heat and light sources.`,
      },
      journey: {
        header: "Garment Journey",
        description: `Wool Selection: This garment is crafted from sheep wool chosen for its natural warmth, density, and durability. The wool provides substantial insulation, making it ideal for cold climates while retaining a refined, structured appearance.
       
        Technique: Carefully tailored and finished through a combination of traditional craftsmanship and precise construction techniques to ensure longevity and comfort.
       
        Artisans & Processes: The piece was brought to life by skilled artisans who oversaw each stage of its creation. From fabric preparation to final finishing, the garment passed through multiple specialized processes to achieve its distinctive form and quality.
       
        Shipping: Each order is thoughtfully packed and dispatched with care from our atelier, ensuring the garment arrives in perfect condition.`,
      },
    },
  },
  {
    slug: "vermillion-jacket",
    name: "Vermillion Jacket",
    price: "400",
    category: "coatAndJackets",
    description:
      "A 4-pocket coat crafted from 100% sheep wool in a deep reddish-crimson shade. Dense and substantial in feel, the pure wool construction provides exceptional warmth and reliable insulation against the cold. The structured silhouette is designed to sit firmly on the body, offering both protection and refined presence. Finished with functional pockets and a timeless cut, this heavy wool coat is ideal for winter wear in the city or countryside, combining durability, comfort, and understated sophistication.",
    material: "100% Sheep Wool",
    variants: [
      {
        color: "#301c15",
        colorLabel: "Reddish Crimson",
        size: ["S", "M", "L"],
        image: [
          VermillionJacket,
          VermillionJacket2,
          VermillionJacket3,
          VermillionJacket4,
        ],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Notch lapel collar
        Single-breasted front
        Button fastening
        Four front patch pockets with buttoned flaps
        Chest patch pockets
        Lower patch pockets
        Structured shoulders
        Buttoned cuffs
        Clean, tailored silhouette
        Regular fit
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `Composition: 100% sheep wool
        
        Care: Eco dry clean only.
        
        This product should be handled with care. We suggest never wearing the product two days in a row, so that the fibres regain their natural structure and texture. Check the label for washing and ironing instructions. Use a professional cleaning service, particularly if your product includes delicate details. Fold carefully and store with cedar balls/moth repellent in a dry place away from heat and light sources.`,
      },
      journey: {
        header: "Garment Journey",
        description: `Wool Selection: This garment is crafted from sheep wool chosen for its natural warmth, density, and durability. The wool provides substantial insulation, making it ideal for cold climates while retaining a refined, structured appearance.
       
        Technique: Carefully tailored and finished through a combination of traditional craftsmanship and precise construction techniques to ensure longevity and comfort.
       
        Artisans & Processes: The piece was brought to life by skilled artisans who oversaw each stage of its creation. From fabric preparation to final finishing, the garment passed through multiple specialized processes to achieve its distinctive form and quality.
       
        Shipping: Each order is thoughtfully packed and dispatched with care from our atelier, ensuring the garment arrives in perfect condition.`,
      },
    },
  },
  {
    slug: "ember-jacket",
    name: "Ember Jacket",
    price: "400",
    category: "coatAndJackets",
    description:
      "A refined single-breasted coat crafted from 100% sheep wool in a warm brown tone with a subtle textured weave. Naturally insulating and substantial in feel, the dense wool fabric offers reliable warmth while maintaining a clean, tailored structure. Designed with classic proportions and understated detailing from everyday wear to more formal settings, offering elegance with practical comfort.",
    material: "100% Sheep Wool",
    variants: [
      {
        color: "#615143",
        colorLabel: "Wood Grain Melange",
        size: ["S", "M", "L"],
        image: [
          EmberJacket,
          EmberJacket2,
          EmberJacket3,
          EmberJacket4,
          EmberJacket5,
          EmberJacket6,
        ],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Notch lapel collar
        Single-breasted front
        Two-button fastening
        Chest welt pocket
        Side welt pockets
        Structured shoulders
        Buttoned cuffs
        Fully lined
        Textured wool finish
        Regular fit
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `Composition: 100% sheep wool
        
        Care: Eco dry clean only.
        
        This product should be handled with care. We suggest never wearing the product two days in a row, so that the fibres regain their natural structure and texture. Check the label for washing and ironing instructions. Use a professional cleaning service, particularly if your product includes delicate details. Fold carefully and store with cedar balls/moth repellent in a dry place away from heat and light sources.`,
      },
      journey: {
        header: "Garment Journey",
        description: `Wool Selection: This garment is crafted from sheep wool chosen for its natural warmth, density, and durability. The wool provides substantial insulation, making it ideal for cold climates while retaining a refined, structured appearance.
       
        Technique: Carefully tailored and finished through a combination of traditional craftsmanship and precise construction techniques to ensure longevity and comfort.
       
        Artisans & Processes: The piece was brought to life by skilled artisans who oversaw each stage of its creation. From fabric preparation to final finishing, the garment passed through multiple specialized processes to achieve its distinctive form and quality.
       
        Shipping: Each order is thoughtfully packed and dispatched with care from our atelier, ensuring the garment arrives in perfect condition.`,
      },
    },
  },
  {
    slug: "horizon-jacket",
    name: "Horizon Jacket",
    price: "400",
    category: "coatAndJackets",
    description:
      "The Horizon Jacket is tailored from a rich wool blend, its warm chestnut plaid exudes the quiet sophistication of old-world luxury. The jacket’s structured silhouette is complemented by a classic point collar and subtle zip closure, while flap pockets at the chest and discreet handwarmer pockets offer both functionality and elegance. Fully lined for comfort, it is a piece that transcends seasons, effortlessly elevating any ensemble with a sense of cultivated ease.",
    material: "100% Sheep Wool",
    variants: [
      {
        color: "#452114",
        colorLabel: "Chocolate Rush",
        size: ["S", "M", "L"],
        image: [
          HorizonJacket,
          HorizonJacket2,
          HorizonJacket3,
          HorizonJacket4,
          HorizonJacket5,
          HorizonJacket6,
        ],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Material: Premium wool blend
        Color: Chestnut plaid with subtle tonal stripes
        Closure: Concealed zip front
        Collar: Classic point collar
        Pockets: Two flap chest pockets with button closure. Two angled handwarmer pockets
        Lining: Soft, full interior lining
        Fit: Tailored yet relaxed, designed for layering
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `Composition: 100% sheep wool
        
        Care: Eco dry clean only.
        
        This product should be handled with care. We suggest never wearing the product two days in a row, so that the fibres regain their natural structure and texture. Check the label for washing and ironing instructions. Use a professional cleaning service, particularly if your product includes delicate details. Fold carefully and store with cedar balls/moth repellent in a dry place away from heat and light sources.`,
      },
      journey: {
        header: "Garment Journey",
        description: `Wool Selection: This garment is crafted from sheep wool chosen for its natural warmth, density, and durability. The wool provides substantial insulation, making it ideal for cold climates while retaining a refined, structured appearance.
       
        Technique: Carefully tailored and finished through a combination of traditional craftsmanship and precise construction techniques to ensure longevity and comfort.
       
        Artisans & Processes: The piece was brought to life by skilled artisans who oversaw each stage of its creation. From fabric preparation to final finishing, the garment passed through multiple specialized processes to achieve its distinctive form and quality.
       
        Shipping: Each order is thoughtfully packed and dispatched with care from our atelier, ensuring the garment arrives in perfect condition.`,
      },
    },
  },
  {
    slug: "aurelia-coat",
    name: "Aurelia Coat",
    price: "400",
    category: "coatAndJackets",
    description:
      "The Regal Red Overcoat is tailored from a rich wool blend, its deep crimson hue exudes the quiet sophistication and luxury. The coat's structured, double-breasted silhouette is complemented by a classic peak lapel and a striking six-button closure, while discreet pockets offer both functionality and elegance. Fully lined for comfort, this coat is a timeless statement piece.",
    material: "100% Sheep Wool",
    variants: [
      {
        color: "#471014",
        colorLabel: "Cherry Picking",
        size: ["S", "M", "L"],
        image: [
          AureliaCoat,
          AureliaCoat2,
          AureliaCoat3,
          AureliaCoat4,
          AureliaCoat5,
          AureliaCoat6,
        ],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Material: Premium wool blend 
        Color: Deep Crimson
        Closure: Double-breasted six-button front
        Collar: Classic peak lapel
        Pockets: Two discreet flap pockets at the hip.
        Lining: Soft, full interior lining
        Fit: Tailored and elegant, designed for a sophisticated drape.
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `
      Dry Clean Only: This garment is made from a premium wool blend and should only be professionally dry cleaned to preserve its structure, color, and fabric integrity.
      
      Spot Cleaning: For minor spills, gently blot the affected area with a clean, damp cloth. Avoid rubbing, which can damage the fibers.
      
      Storage: Store your coat on a wide, padded hanger to maintain its shape, especially in the shoulders. Keep it in a cool, dry place away from direct sunlight to prevent fading. Use a breathable garment bag for long-term storage to protect it from dust and moths.
      
      Avoid Over-Wearing: Allow the coat to rest between wears to help the wool fibers recover and prevent creasing.
      
      Steaming: If creased, use a garment steamer on a low setting. Hold the steamer a few inches away from the fabric. Do not iron directly, as this can flatten the wool pile and create shine.
      
      Brushing: Use a soft-bristle garment brush to gently remove surface dust, lint, and pet hair. Brush in the direction of the fabric's nap.e details. Fold carefully and store with cedar balls/moth repellent in a dry place away from heat and light sources.`,
      },
      journey: {
        header: "Garment Journey",
        description: `Wool Selection: This garment is crafted from sheep wool chosen for its natural warmth, density, and durability. The wool provides substantial insulation, making it ideal for cold climates while retaining a refined, structured appearance.
       
        Technique: The selected wool is expertly dyed to achieve the rich, deep crimson hue, then blended to create a luxurious, durable fabric. Skilled pattern makers precisely cut each piece of the coat, ensuring a flawless drape and tailored silhouette.
       
        Artisans & Processes: Experienced artisans hand-assemble the coat, carefully stitching each seam, attaching the classic peak lapels, and securing the elegant double-breasted buttons.
       
        Shipping: Each order is thoughtfully packed and dispatched with care from our atelier, ensuring the garment arrives in perfect condition.`,
      },
    },
  },
  {
    slug: "obsidian-coat",
    name: "Obsidian Cloak",
    price: "400",
    category: "coatAndJackets",
    description:
      "An essential garment for refined elegance, this single-breasted coat reveals a sophisticated design enhanced by a clean, structured silhouette. It is rendered in a luxurious yet lightweight wool blend, offering both warmth and a graceful drape. Framed by classic lapels and featuring a discreet button closure, it feels timeless and contemporary at once.",
    material: "100% Sheep Wool",
    variants: [
      {
        color: "#121215",
        colorLabel: "Classic Black",
        size: ["S", "M", "L"],
        image: [
          ObsidianCoat,
          ObsidianCoat2,
          ObsidianCoat3,
          ObsidianCoat4,
          ObsidianCoat5,
          ObsidianCoat6,
        ],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Material: Premium wool blend
            Color: Classic Black
            Closure: Single-breasted two-button front
            Collar: Classic notched lapel
            Pockets: Two discreet flap pockets at the hip
            Lining: Soft, full interior lining
            Fit: Tailored and structured, designed for a sleek silhouette.
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `
      Dry Clean Only: This garment is made from a premium wool blend and should only be professionally dry cleaned to preserve its structure, color, and fabric integrity.
      
      Spot Cleaning: For minor spills, gently blot the affected area with a clean, damp cloth. Avoid rubbing, which can damage the fibers.
      
      Storage: Store your coat on a wide, padded hanger to maintain its shape, especially in the shoulders. Keep it in a cool, dry place away from direct sunlight to prevent fading. Use a breathable garment bag for long-term storage to protect it from dust and moths.
      
      Avoid Over-Wearing: Allow the coat to rest between wears to help the wool fibers recover and prevent creasing.
      
      Steaming: If creased, use a garment steamer on a low setting. Hold the steamer a few inches away from the fabric. Do not iron directly, as this can flatten the wool pile and create shine.
      
      Brushing: Use a soft-bristle garment brush to gently remove surface dust, lint, and pet hair. Brush in the direction of the fabric's nap.e details. Fold carefully and store with cedar balls/moth repellent in a dry place away from heat and light sources.`,
      },
      journey: {
        header: "Garment Journey",
        description: `Wool Selection: This garment is crafted from sheep wool chosen for its natural warmth, density, and durability. The wool provides substantial insulation, making it ideal for cold climates while retaining a refined, structured appearance.
       
        Technique: The selected wool is expertly dyed to achieve the rich, deep black hue, then blended to create a luxurious, durable fabric. Skilled pattern makers precisely cut each piece of the coat, ensuring a flawless drape and tailored silhouette.
       
        Artisans & Processes: Experienced artisans hand-assemble the coat, carefully stitching each seam, attaching the classic peak lapels, and securing the elegant double-breasted buttons.
       
        Shipping: Each order is thoughtfully packed and dispatched with care from our atelier, ensuring the garment arrives in perfect condition.`,
      },
    },
  },
  {
    slug: "celestine-coat",
    name: "Celestine Coat",
    price: "400",
    category: "coatAndJackets",
    description:
      "This striking emerald green overcoat is meticulously tailored from a rich wool blend, its vibrant hue exuding both modern flair and timeless sophistication. The coat features a structured, double-breasted silhouette with a classic peak lapel, creating a powerful yet elegant statement. Discreet pockets offer practical functionality, while the fully lined interior ensures comfort, making this coat a standout addition to any wardrobe.",
    material: "100% Sheep Wool",
    variants: [
      {
        color: "#3e8c85",
        colorLabel: "Dark Cyan",
        size: ["S", "M", "L"],
        image: [
          CelestineCoat,
          CelestineCoat2,
          CelestineCoat3,
          CelestineCoat4,
          CelestineCoat5,
          CelestineCoat6,
        ],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Material: Premium wool blend
        Color: Dark Cyan
        Closure: Double-breasted six-button front
        Collar: Classic peak lapel
        Pockets: Two discreet flap pockets at the hip
        Lining: Soft, full interior lining
        Fit: Tailored and elegant, designed for a sophisticated drape.
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `
      Dry Clean Only: This garment is made from a premium wool blend and should only be professionally dry cleaned to preserve its structure, color, and fabric integrity.
      
      Spot Cleaning: For minor spills, gently blot the affected area with a clean, damp cloth. Avoid rubbing, which can damage the fibers.
      
      Storage: Store your coat on a wide, padded hanger to maintain its shape, especially in the shoulders. Keep it in a cool, dry place away from direct sunlight to prevent fading. Use a breathable garment bag for long-term storage to protect it from dust and moths.
      
      Avoid Over-Wearing: Allow the coat to rest between wears to help the wool fibers recover and prevent creasing.
      
      Steaming: If creased, use a garment steamer on a low setting. Hold the steamer a few inches away from the fabric. Do not iron directly, as this can flatten the wool pile and create shine.
      
      Brushing: Use a soft-bristle garment brush to gently remove surface dust, lint, and pet hair. Brush in the direction of the fabric's nap.e details. Fold carefully and store with cedar balls/moth repellent in a dry place away from heat and light sources.`,
      },
      journey: {
        header: "Garment Journey",
        description: `Wool Selection: This garment is crafted from sheep wool chosen for its natural warmth, density, and durability. The wool provides substantial insulation, making it ideal for cold climates while retaining a refined, structured appearance.
       
        Technique: The selected wool is expertly dyed to achieve the rich, dark cyan hue, then blended to create a luxurious, durable fabric. Skilled pattern makers precisely cut each piece of the coat, ensuring a flawless drape and tailored silhouette.
       
        Artisans & Processes: Experienced artisans hand-assemble the coat, carefully stitching each seam, attaching the classic peak lapels, and securing the elegant double-breasted buttons.
       
        Shipping: Each order is thoughtfully packed and dispatched with care from our atelier, ensuring the garment arrives in perfect condition.`,
      },
    },
  },
  {
    slug: "valence-sweater",
    name: "Valence Sweater",
    price: "400",
    category: "knitwear",
    description:
      "Crafted from the finest pure cashmere, this timeless cardigan offers unparalleled softness and lightweight warmth. Its classic V-neck silhouette is elegantly framed by contrasting trim, adding a touch of sophisticated detail. Featuring a full button-front closure and a relaxed fit, this sweater is a versatile essential, perfect for effortless layering or as a standalone piece for luxurious comfort.",
    material: "100% Baby Cashmere",
    variants: [
      {
        color: "#9f8872",
        colorLabel: "Gramps Shoehorn",
        size: ["S", "M", "L"],
        image: [
          ValenceSweater,
          ValenceSweater2,
          ValenceSweater3,
          ValenceSweater4,
        ],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Material: 100% Pure Cashmere
        Color: Warm Beige with Contrast Trim
        Neckline: V-neck
        Closure: Full button front
        Details: Rib-knit cuffs and hem with contrast trim
        Fit: Relaxed and comfortable, ideal for layering.
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `
       Hand Wash Recommended: Gently hand wash in cool water (max 30°C / 86°F) using a specialized cashmere or mild wool detergent.
       
       Drying: Gently squeeze out excess water (do not wring). Lay the sweater flat on a clean, dry towel, reshaping it to its original dimensions. Roll the sweater in the towel to absorb more water. Unroll and lay flat on a fresh, dry surface or a mesh drying rack, away from direct sunlight or heat, until completely dry.
       
       Storage: Fold your cashmere sweater neatly and store it in a drawer or on a shelf. Avoid hanging, as this can cause stretching. Use cedar blocks or lavender sachets to deter moths.
       
       Avoid: Harsh detergents, hot water, tumble drying, bleach, and ironing. If pressing is necessary, use a cool iron with a damp cloth between the iron and the sweater.
       `,
      },
      journey: {
        header: "Garment Journey",
        description: `Fleece Sourcing: The journey begins with the careful collection of the finest, softest undercoat fibers from our cashmere goats, from the himalayas.
        
        Sorting & De-hairing: The raw cashmere is sorted by hand to separate the longest, finest fibers, and then de-haired to remove coarser guard hairs.
        
        Washing & Dyeing: The pure cashmere fibers are gently washed to remove impurities, then dyed to achieve the desired warm beige and contrasting trim colors.
        
        Knitting: Advanced knitting machines or hand-knitting techniques transform the yarn into the cardigan's soft, coherent fabric, including the neck, body, sleeves, and trim.
        
        Assembly & Finishing: Individual knitted pieces are expertly linked or sewn together. Buttons are attached, and the garment undergoes a gentle washing and pressing process to achieve its final luxurious feel and shape.
        
        Quality Control: Each sweater is thoroughly inspected to ensure it meets the highest standards of craftsmanship, softness, and finish before being prepared.
`,
      },
    },
  },
  {
    slug: "mist-pullover",
    name: "Mist Pullover",
    price: "400",
    category: "knitwear",
    description:
      "This refined long-sleeve polo sweater is crafted from a soft, textured knit in a versatile light grey marl, offering both comfort and understated style. It features a classic spread collar with an open V-neck placket, providing a modern yet timeless appeal. The relaxed fit, coupled with ribbed cuffs and hem, ensures a comfortable drape, making it an ideal choice for elevated casual wear.",
    material: "100% Cashmere",
    variants: [
      {
        color: "#dedbd9",
        colorLabel: "Porcelian",
        size: ["S", "M", "L"],
        image: [MistPullover, MistPullover2, MistPullover3, MistPullover4],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Material: Soft Knit Blend 
        Color: Light Grey Marl
        Neckline: Spread collar with open V-neck placket
        Sleeves: Long sleeves
        Details: Rib-knit cuffs and hem
        Fit: Relaxed and comfortable.
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `
       Hand Wash Recommended: Gently hand wash in cool water (max 30°C / 86°F) using a specialized cashmere or mild wool detergent.
       
       Drying: Gently squeeze out excess water (do not wring). Lay the sweater flat on a clean, dry towel, reshaping it to its original dimensions. Roll the sweater in the towel to absorb more water. Unroll and lay flat on a fresh, dry surface or a mesh drying rack, away from direct sunlight or heat, until completely dry.
       
       Storage: Fold your cashmere sweater neatly and store it in a drawer or on a shelf. Avoid hanging, as this can cause stretching. Use cedar blocks or lavender sachets to deter moths.
       
       Avoid: Harsh detergents, hot water, tumble drying, bleach, and ironing. If pressing is necessary, use a cool iron with a damp cloth between the iron and the sweater.
       `,
      },
      journey: {
        header: "Garment Journey",
        description: `Fleece Sourcing: The journey begins with the careful collection of the finest, softest undercoat fibers from our cashmere goats, from the himalayas.
        
        Sorting & De-hairing: The raw cashmere is sorted by hand to separate the longest, finest fibers, and then de-haired to remove coarser guard hairs.
        
        Washing & Dyeing: The pure cashmere fibers are gently washed to remove impurities, then dyed to achieve the desired colors.

        Knitting: Advanced knitting machines or hand-knitting techniques transform the yarn into the cardigan's soft, coherent fabric, including the neck, body, sleeves, and trim.
        
        Assembly & Finishing: Individual knitted pieces are expertly linked or sewn together. Buttons are attached, and the garment undergoes a gentle washing and pressing process to achieve its final luxurious feel and shape.
        
        Quality Control: Each sweater is thoroughly inspected to ensure it meets the highest standards of craftsmanship, softness, and finish before being prepared.
`,
      },
    },
  },
  {
    slug: "sandstone-pullover",
    name: "Sandstone Pullover",
    price: "400",
    category: "knitwear",
    description:
      "This versatile crew-neck sweater is crafted from a soft, lightweight knit in a classic beige hue, offering effortless elegance and comfort. Its clean, understated design features a finely ribbed crew neckline, cuffs, and hem, ensuring a polished finish. With a relaxed yet refined fit, this sweater is an essential wardrobe staple, perfect for layering or wearing on its own for a subtly sophisticated look.",
    material: "100% Cashmere",
    variants: [
      {
        color: "#bfad99",
        colorLabel: "Classic Beige",
        size: ["S", "M", "L"],
        image: [
          SandstonePullover,
          SandstonePullover2,
          SandstonePullover3,
          SandstonePullover4,
        ],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Material: Soft, Lightweight Knit Blend 
        Color: Classic Beige
        Neckline: Crew Neck
        Sleeves: Long sleeves
        Details: Finely ribbed collar, cuffs, and hem
        Fit: Relaxed yet refined.
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `
       Hand Wash Recommended: Gently hand wash in cool water (max 30°C / 86°F) using a specialized cashmere or mild wool detergent.
       
       Drying: Gently squeeze out excess water (do not wring). Lay the sweater flat on a clean, dry towel, reshaping it to its original dimensions. Roll the sweater in the towel to absorb more water. Unroll and lay flat on a fresh, dry surface or a mesh drying rack, away from direct sunlight or heat, until completely dry.
       
       Storage: Fold your cashmere sweater neatly and store it in a drawer or on a shelf. Avoid hanging, as this can cause stretching. Use cedar blocks or lavender sachets to deter moths.
       
       Avoid: Harsh detergents, hot water, tumble drying, bleach, and ironing. If pressing is necessary, use a cool iron with a damp cloth between the iron and the sweater.
       `,
      },
      journey: {
        header: "Garment Journey",
        description: `Fleece Sourcing: The journey begins with the careful collection of the finest, softest undercoat fibers from our cashmere goats, from the himalayas.
        
        Sorting & De-hairing: The raw cashmere is sorted by hand to separate the longest, finest fibers, and then de-haired to remove coarser guard hairs.
        
        Washing & Dyeing: The pure cashmere fibers are gently washed to remove impurities, then dyed to achieve the desired colors.

        Knitting: Advanced knitting machines or hand-knitting techniques transform the yarn into the cardigan's soft, coherent fabric, including the neck, body, sleeves, and trim.
        
        Assembly & Finishing: Individual knitted pieces are expertly linked or sewn together. Buttons are attached, and the garment undergoes a gentle washing and pressing process to achieve its final luxurious feel and shape.
        
        Quality Control: Each sweater is thoroughly inspected to ensure it meets the highest standards of craftsmanship, softness, and finish before being prepared.
`,
      },
    },
  },
  {
    slug: "lumen-turtleneck",
    name: "Lumen Turtleneck",
    price: "400",
    category: "knitwear",
    description:
      "This elegant turtleneck sweater is crafted from a soft, fine-gauge knit in a rich chocolate brown hue, offering sophisticated warmth and comfort. Its minimalist design features a refined, slightly raised collar and finely ribbed cuffs and hem, ensuring a sleek and polished silhouette. With a versatile fit that can be dressed up or down, this sweater is a timeless staple for any discerning wardrobe.",
    material: "100% Cashmere",
    variants: [
      {
        color: "#332019",
        colorLabel: "Braised Plum",
        size: ["S", "M", "L"],
        image: [
          LumenTurtleneck,
          LumenTurtleneck2,
          LumenTurtleneck3,
          LumenTurtleneck4,
        ],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Material: Soft, Fine-Gauge Knit Blend 
        Color: Rich Chocolate Brown
        Neckline: Mock Neck
        Sleeves: Long sleeves
        Details: Finely ribbed collar, cuffs, and hem
        Fit: Refined and versatile.
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `
       Hand Wash Recommended: Gently hand wash in cool water (max 30°C / 86°F) using a specialized cashmere or mild wool detergent.
       
       Drying: Gently squeeze out excess water (do not wring). Lay the sweater flat on a clean, dry towel, reshaping it to its original dimensions. Roll the sweater in the towel to absorb more water. Unroll and lay flat on a fresh, dry surface or a mesh drying rack, away from direct sunlight or heat, until completely dry.
       
       Storage: Fold your cashmere sweater neatly and store it in a drawer or on a shelf. Avoid hanging, as this can cause stretching. Use cedar blocks or lavender sachets to deter moths.
       
       Avoid: Harsh detergents, hot water, tumble drying, bleach, and ironing. If pressing is necessary, use a cool iron with a damp cloth between the iron and the sweater.
       `,
      },
      journey: {
        header: "Garment Journey",
        description: `Fleece Sourcing: The journey begins with the careful collection of the finest, softest undercoat fibers from our cashmere goats, from the himalayas.
        
        Sorting & De-hairing: The raw cashmere is sorted by hand to separate the longest, finest fibers, and then de-haired to remove coarser guard hairs.
        
        Washing & Dyeing: The pure cashmere fibers are gently washed to remove impurities, then dyed to achieve the desired colors.

        Knitting: Advanced knitting machines or hand-knitting techniques transform the yarn into the cardigan's soft, coherent fabric, including the neck, body, sleeves, and trim.
        
        Assembly & Finishing: Individual knitted pieces are expertly linked or sewn together. Buttons are attached, and the garment undergoes a gentle washing and pressing process to achieve its final luxurious feel and shape.
        
        Quality Control: Each sweater is thoroughly inspected to ensure it meets the highest standards of craftsmanship, softness, and finish before being prepared.
`,
      },
    },
  },
  {
    slug: "alba-turtleneck",
    name: "Alba Turtleneck",
    price: "400",
    category: "knitwear",
    description:
      "This pristine turtleneck sweater is crafted from a soft, fine-gauge knit in a versatile ivory hue, offering sophisticated warmth and effortless style. Its clean, minimalist design features a refined, slightly raised collar and finely ribbed cuffs and hem, ensuring a sleek and polished silhouette. With a timeless appeal and a comfortable fit, this sweater is a versatile staple perfect for any occasion.",
    material: "100% Cashmere",
    variants: [
      {
        color: "#e7e7de",
        colorLabel: "White Snow",
        size: ["S", "M", "L"],
        image: [
          AlbaTurtleneck,
          AlbaTurtleneck2,
          AlbaTurtleneck3,
          AlbaTurtleneck4,
        ],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Material: Soft, Fine-Gauge Knit Blend 
        Color: Ivory
        Neckline: Mock Neck
        Sleeves: Long sleeves
        Details: Finely ribbed collar, cuffs, and hem
        Fit: Refined and versatile.
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `
       Hand Wash Recommended: Gently hand wash in cool water (max 30°C / 86°F) using a specialized cashmere or mild wool detergent.
       
       Drying: Gently squeeze out excess water (do not wring). Lay the sweater flat on a clean, dry towel, reshaping it to its original dimensions. Roll the sweater in the towel to absorb more water. Unroll and lay flat on a fresh, dry surface or a mesh drying rack, away from direct sunlight or heat, until completely dry.
       
       Storage: Fold your cashmere sweater neatly and store it in a drawer or on a shelf. Avoid hanging, as this can cause stretching. Use cedar blocks or lavender sachets to deter moths.
       
       Avoid: Harsh detergents, hot water, tumble drying, bleach, and ironing. If pressing is necessary, use a cool iron with a damp cloth between the iron and the sweater.
       `,
      },
      journey: {
        header: "Garment Journey",
        description: `Fleece Sourcing: The journey begins with the careful collection of the finest, softest undercoat fibers from our cashmere goats, from the himalayas.
        
        Sorting & De-hairing: The raw cashmere is sorted by hand to separate the longest, finest fibers, and then de-haired to remove coarser guard hairs.
        
        Washing & Dyeing: The pure cashmere fibers are gently washed to remove impurities, then dyed to achieve the desired colors.

        Knitting: Advanced knitting machines or hand-knitting techniques transform the yarn into the cardigan's soft, coherent fabric, including the neck, body, sleeves, and trim.
        
        Assembly & Finishing: Individual knitted pieces are expertly linked or sewn together. Buttons are attached, and the garment undergoes a gentle washing and pressing process to achieve its final luxurious feel and shape.
        
        Quality Control: Each sweater is thoroughly inspected to ensure it meets the highest standards of craftsmanship, softness, and finish before being prepared.
`,
      },
    },
  },
  {
    slug: "mist-trousers",
    name: "Mist Trousers",
    price: "400",
    category: "trousers",
    description:
      "These comfortable and versatile sweatpants are crafted from a soft, heathered fleece in a light grey shade, offering ultimate relaxation and everyday style. Featuring a flexible elastic waistband with an adjustable drawstring, they provide a personalized fit. The straight-leg cut ensures a modern silhouette, while discreet side pockets add practical functionality, making them perfect for lounging or casual outings.",
    material: "100% Cashmere",
    variants: [
      {
        color: "#dedbd9",
        colorLabel: "Porcelian",
        size: ["S", "M", "L"],
        image: [GrayTrousers, GrayTrousers2, GrayTrousers3],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Material: Soft Heathered Fleece (Cotton blend assumed)
        Color: Light Grey Heather
        Waist: Elastic waistband with adjustable drawstring
        Leg Style: Straight leg
        Pockets: Two discreet side pockets
        Fit: Relaxed and comfortable.
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `
       Hand Wash Recommended: Gently hand wash in cool water (max 30°C / 86°F) using a specialized cashmere or mild wool detergent.
       
       Drying: Gently squeeze out excess water (do not wring). Lay the sweater flat on a clean, dry towel, reshaping it to its original dimensions. Roll the sweater in the towel to absorb more water. Unroll and lay flat on a fresh, dry surface or a mesh drying rack, away from direct sunlight or heat, until completely dry.
       
       Storage: Fold your cashmere sweater neatly and store it in a drawer or on a shelf. Avoid hanging, as this can cause stretching. Use cedar blocks or lavender sachets to deter moths.
       
       Avoid: Harsh detergents, hot water, tumble drying, bleach, and ironing. If pressing is necessary, use a cool iron with a damp cloth between the iron and the sweater.
       `,
      },
      journey: {
        header: "Garment Journey",
        description: `Fleece Sourcing: The journey begins with the careful collection of the finest, softest undercoat fibers from our cashmere goats, from the himalayas.
        
        Sorting & De-hairing: The raw cashmere is sorted by hand to separate the longest, finest fibers, and then de-haired to remove coarser guard hairs.
        
        Washing & Dyeing: The pure cashmere fibers are gently washed to remove impurities, then dyed to achieve the desired colors.

        Knitting: Advanced knitting machines or hand-knitting techniques transform the yarn into the cardigan's soft, coherent fabric, including the body, sleeves, and trim.
        
        Assembly & Finishing: Individual knitted pieces are expertly linked or sewn together. Buttons are attached, and the garment undergoes a gentle washing and pressing process to achieve its final luxurious feel and shape.
        
        Quality Control: Each sweater is thoroughly inspected to ensure it meets the highest standards of craftsmanship, softness, and finish before being prepared.
`,
      },
    },
  },
  {
    slug: "sandstorm-trousers",
    name: "Sandstorm Trousers",
    price: "400",
    category: "trousers",
    description:
      "These comfortable and versatile sweatpants are crafted from a soft, heathered fleece in a classic beige shade, offering ultimate relaxation and everyday style. Featuring a flexible elastic waistband with an adjustable drawstring, they provide a personalized fit. The straight-leg cut ensures a modern silhouette, while discreet side pockets add practical functionality, making them perfect for lounging or casual outings.",
    material: "100% Cashmere",
    variants: [
      {
        color: "#bfad99",
        colorLabel: "Classic Beige",
        size: ["S", "M", "L"],
        image: [BeigeTrousers, BeigeTrousers2, BeigeTrousers3],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Material: Soft Heathered Fleece 
        Color: Classic Beige
        Waist: Elastic waistband with adjustable drawstring
        Leg Style: Straight leg
        Pockets: Two discreet side pockets
        Fit: Relaxed and comfortable.
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `
       Hand Wash Recommended: Gently hand wash in cool water (max 30°C / 86°F) using a specialized cashmere or mild wool detergent.
       
       Drying: Gently squeeze out excess water (do not wring). Lay the sweater flat on a clean, dry towel, reshaping it to its original dimensions. Roll the sweater in the towel to absorb more water. Unroll and lay flat on a fresh, dry surface or a mesh drying rack, away from direct sunlight or heat, until completely dry.
       
       Storage: Fold your cashmere sweater neatly and store it in a drawer or on a shelf. Avoid hanging, as this can cause stretching. Use cedar blocks or lavender sachets to deter moths.
       
       Avoid: Harsh detergents, hot water, tumble drying, bleach, and ironing. If pressing is necessary, use a cool iron with a damp cloth between the iron and the sweater.
       `,
      },
      journey: {
        header: "Garment Journey",
        description: `Fleece Sourcing: The journey begins with the careful collection of the finest, softest undercoat fibers from our cashmere goats, from the himalayas.
        
        Sorting & De-hairing: The raw cashmere is sorted by hand to separate the longest, finest fibers, and then de-haired to remove coarser guard hairs.
        
        Washing & Dyeing: The pure cashmere fibers are gently washed to remove impurities, then dyed to achieve the desired colors.

        Knitting: Advanced knitting machines or hand-knitting techniques transform the yarn into the cardigan's soft, coherent fabric, including the body, sleeves, and trim.
        
        Assembly & Finishing: Individual knitted pieces are expertly linked or sewn together. Buttons are attached, and the garment undergoes a gentle washing and pressing process to achieve its final luxurious feel and shape.
        
        Quality Control: Each sweater is thoroughly inspected to ensure it meets the highest standards of craftsmanship, softness, and finish before being prepared.
`,
      },
    },
  },
  {
    slug: "azurine-robe",
    name: "Azurine Robe",
    price: "400",
    category: "robe",
    description:
      "Indulge in vibrant comfort with this charming bathrobe, crafted from durable duck cotton and adorned with a lively botanical print against a serene blue backdrop. Featuring an array of colorful flowers and distinctive cactus motifs, this robe offers a unique blend of artistry and relaxation. Its classic kimono silhouette, complete with a self-tie belt and practical patch pockets, ensures a comfortable and stylish fit for your moments of unwind.",
    material: "100% Duck Cotton",
    variants: [
      {
        color: "#618cb3",
        colorLabel: "Sea Salt Rivers",
        size: ["S", "M", "L"],
        image: [RobeBlue, RobeBlue2, RobeBlue3, RobeBlue4],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Material: 100% Duck Cotton
        Color: Blue with Multi-color Botanical Print (Flowers and Cacti)
        Style: Kimono style with self-tie belt
        Sleeves: Three-quarter length sleeves
        Pockets: Two front patch pockets
        Fit: Relaxed and comfortable.
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `
          Machine Wash Cold: Wash with similar colors on a gentle cycle.
          
          Tumble Dry Low: Remove promptly to avoid wrinkles.
          
          Do Not Bleach: Use mild, color-safe detergent
        `,
      },
    },
  },
  {
    slug: "marigold-robe",
    name: "Marigold Robe",
    price: "400",
    category: "robe",
    description:
      "Indulge in vibrant comfort with this charming bathrobe, crafted from durable duck cotton and adorned with a lively botanical print against a vibrant orange backdrop. Featuring an array of colorful flowers and distinctive cactus motifs, this robe offers a unique blend of artistry and relaxation. Its classic kimono silhouette, complete with a self-tie belt and practical patch pockets, ensures a comfortable and stylish fit for your moments of unwind.",
    material: "100% Duck Cotton",
    variants: [
      {
        color: "#d98040",
        colorLabel: "Spiced Up Orange",
        size: ["S", "M", "L"],
        image: [RobeOrange, RobeOrange2, RobeOrange3, RobeOrange4],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Material: 100% Duck Cotton
        Color: Orange with Multi-color Botanical Print (Flowers and Cacti)
        Style: Kimono style with self-tie belt
        Sleeves: Three-quarter length sleeves
        Pockets: Two front patch pockets
        Fit: Relaxed and comfortable.
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `
          Machine Wash Cold: Wash with similar colors on a gentle cycle.
          
          Tumble Dry Low: Remove promptly to avoid wrinkles.
          
          Do Not Bleach: Use mild, color-safe detergent
        `,
      },
    },
  },
  {
    slug: "solistice-shawl",
    name: "Solistice Shawl",
    price: "400",
    category: "shawl",
    description:
      "Wrap yourself in refined comfort with this beautifully woven shawl, featuring a sophisticated striped pattern in an inviting palette of earthy beige, soft blue, and warm yellow. Crafted from a luxurious and soft fabric, it offers both warmth and a gentle drape. Finished with delicate fringed edges, this versatile accessory effortlessly adds a touch of elegance and color to any ensemble, making it perfect for both brisk days and stylish evenings.",
    material: "100% Pashmina",
    variants: [
      {
        color: "#ad9f93",
        color: "#ad9f93",
        colorLabel: "Sombrero",
        size: ["S", "M", "L"],
        image: [YellowShawl, YellowShawl2, YellowShawl3],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Material: Soft Woven Blend 
        Color: Multi-stripe pattern 
        Shape: Rectangular Shawl
        Details: Fringed edges
        Dimensions: Generous length for versatile styling (assuming standard shawl size)
        Texture: Soft, drapes easily.
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `
        Dry Clean Recommended: For best results, professional dry cleaning is advised.
        
        Gentle Hand Wash: Use cold water and a specialized detergent; do not twist or wring.
        
        Air Dry Flat: Reshape and lay flat on a clean towel, away from direct heat or sunlight.
        `,
      },
      journey: {
        header: "Garment Journey",
        description: `
        Himalayan Fiber Collection: Finest fibers are ethically hand-combed from goats in the Himalayas.
        
        Yarn Creation & Weaving: Fibers are meticulously sorted, cleaned, and spun into fine yarn, then hand-woven into the striped shawl.
        
        Artisanal Finishing: The shawl is expertly dyed, hand-fringed, and undergoes final checks to ensure its luxurious quality.
        `,
      },
    },
  },
  {
    slug: "apricotta-shawl",
    name: "Apricotta Shawl",
    price: "400",
    category: "shawl",
    description:
      "Elevate your style with this beautifully woven shawl, featuring a sophisticated striped pattern infused with delicate geometric and textural details. The inviting color palette of soft peach, warm beige, and subtle grey creates a harmonious and elegant look. Crafted from a luxurious and soft fabric, it offers both warmth and a graceful drape. Finished with classic fringed edges, this versatile accessory effortlessly adds a touch of intricate charm and cozy elegance to any ensemble.",
    material: "100% Pashmina",
    variants: [
      {
        color: "#d5b29a",
        color: "#d5b29a",
        colorLabel: "Apricotta",
        size: ["S", "M", "L"],
        image: [PinkShawl, PinkShawl2, PinkShawl3],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Material: Soft Woven Blend (specific fibers not visible but inferring from image)
        Color: Multi-stripe pattern (Peach, Beige, Grey with textured details)
        Shape: Rectangular Shawl
        Details: Fringed edges, woven geometric patterns within stripes
        Dimensions: Generous length for versatile styling 
        Texture: Soft, drapes easily, subtle woven texture.
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `
        Dry Clean Recommended: For best results, professional dry cleaning is advised.
        
        Gentle Hand Wash: Use cold water and a specialized detergent; do not twist or wring.
        
        Air Dry Flat: Reshape and lay flat on a clean towel, away from direct heat or sunlight.
        `,
      },
      journey: {
        header: "Garment Journey",
        description: `
        Himalayan Fiber Collection: Finest fibers are ethically hand-combed from goats in the Himalayas.
        
        Yarn Creation & Weaving: Fibers are meticulously sorted, cleaned, and spun into fine yarn, then hand-woven into the striped shawl.
        
        Artisanal Finishing: The shawl is expertly dyed, hand-fringed, and undergoes final checks to ensure its luxurious quality.
        `,
      },
    },
  },
  {
    slug: "latte-shawl",
    name: "Latte Shawl",
    price: "400",
    category: "shawl",
    description:
      "Elevate your style with this beautifully woven shawl, featuring a sophisticated striped pattern infused with delicate geometric and textural details. The inviting color palette of dark brown, warm beige, and subtle yellow creates a harmonious and elegant look. Crafted from a luxurious and soft fabric, it offers both warmth and a graceful drape. Finished with classic fringed edges, this versatile accessory effortlessly adds a touch of intricate charm and cozy elegance to any ensemble.",
    material: "100% Pashmina",
    variants: [
      {
        color: "#684f3e",
        color: "#684f3e",
        colorLabel: "Cookie Crumble",
        size: ["S", "M", "L"],
        image: [BrownShawl, BrownShawl2, BrownShawl3],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Material: Soft Woven Blend 
        Color: Multi-stripe pattern
        Shape: Rectangular Shawl
        Details: Fringed edges, woven geometric patterns within stripes
        Dimensions: Generous length for versatile styling 
        Texture: Soft, drapes easily, subtle woven texture.
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `
        Dry Clean Recommended: For best results, professional dry cleaning is advised.
        
        Gentle Hand Wash: Use cold water and a specialized detergent; do not twist or wring.
        
        Air Dry Flat: Reshape and lay flat on a clean towel, away from direct heat or sunlight.
        `,
      },
      journey: {
        header: "Garment Journey",
        description: `
        Himalayan Fiber Collection: Finest fibers are ethically hand-combed from goats in the Himalayas.
        
        Yarn Creation & Weaving: Fibers are meticulously sorted, cleaned, and spun into fine yarn, then hand-woven into the striped shawl.
        
        Artisanal Finishing: The shawl is expertly dyed, hand-fringed, and undergoes final checks to ensure its luxurious quality.
        `,
      },
    },
  },
  {
    slug: "mandala-shawl",
    name: "Mandala Shawl",
    price: "400",
    category: "shawl",
    description:
      "Effortlessly elegant, this beautifully woven shawl showcases a sophisticated gradient striped pattern in rich, earthy tones of gray and deep blue. Crafted from a soft, luxurious fabric, it provides comforting warmth and a graceful drape. Finished with classic fringed edges, this versatile accessory is perfect for adding a touch of understated sophistication and cozy style to any look, suitable for both cooler days and chic evenings.",
    material: "100% Pashmina",
    variants: [
      {
        color: "#2c3241",
        colorLabel: "Midnight",
        size: ["S", "M", "L"],
        image: [BlueShawl, BlueShawl2, BlueShawl3],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Material: Soft Woven Blend 
        Color: Graduated Multi-stripe pattern 
        Shape: Rectangular Shawl
        Details: Fringed edges
        Dimensions: Generous length for versatile styling 
        Texture: Soft, drapes easily.
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `
        Dry Clean Recommended: For best results, professional dry cleaning is advised.
        
        Gentle Hand Wash: Use cold water and a specialized detergent; do not twist or wring.
        
        Air Dry Flat: Reshape and lay flat on a clean towel, away from direct heat or sunlight.
        `,
      },
      journey: {
        header: "Garment Journey",
        description: `
        Himalayan Fiber Collection: Finest fibers are ethically hand-combed from goats in the Himalayas.
        
        Yarn Creation & Weaving: Fibers are meticulously sorted, cleaned, and spun into fine yarn, then hand-woven into the striped shawl.
       
        Artisanal Finishing: The shawl is expertly dyed, hand-fringed, and undergoes final checks to ensure its luxurious quality.
        `,
      },
    },
  },
  {
    slug: "skyvory-gloves",
    name: "Skyvory Gloves",
    price: "400",
    category: "accessories",
    description:
      "Indulge in the unparalleled softness and warmth of these cashmere gloves. Crafted from a luxurious, soft woven blend, they offer exceptional comfort and a refined touch to any ensemble. The timeless design and superior material make them a perfect accessory for colder days.",
    material: "100% Cashmere",
    variants: [
      {
        color: "#e9e5da",
        colorLabel: "Cream White",
        size: ["S", "M", "L"],
        image: [GlovesWhite, GlovesWhite2],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Material: Soft Woven Blend
        Color: Cream White
        Shape: Classic five-finger glove
        Details: Ribbed cuffs for a secure and comfortable fit
        Texture: Incredibly soft, smooth, and warm
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `
       Hand Wash Recommended: Gently hand wash in cool water (max 30°C / 86°F) using a specialized cashmere or mild wool detergent.
       
       Drying: Gently squeeze out excess water (do not wring). Lay the sweater flat on a clean, dry towel, reshaping it to its original dimensions. Roll the sweater in the towel to absorb more water. Unroll and lay flat on a fresh, dry surface or a mesh drying rack, away from direct sunlight or heat, until completely dry.
       
       Storage: Fold your cashmere sweater neatly and store it in a drawer or on a shelf. Avoid hanging, as this can cause stretching. Use cedar blocks or lavender sachets to deter moths.
       
       Avoid: Harsh detergents, hot water, tumble drying, bleach, and ironing. If pressing is necessary, use a cool iron with a damp cloth between the iron and the sweater.
       `,
      },
      journey: {
        header: "Garment Journey",
        description: `Fleece Sourcing: The journey begins with the careful collection of the finest, softest undercoat fibers from our cashmere goats, from the himalayas.
        
        Sorting & De-hairing: The raw cashmere is sorted by hand to separate the longest, finest fibers, and then de-haired to remove coarser guard hairs.
        
        Washing & Dyeing: The pure cashmere fibers are gently washed to remove impurities, then dyed to achieve the desired colors.

        Knitting: Advanced knitting machines or hand-knitting techniques transform the yarn into the cardigan's soft, coherent fabric, including the body, sleeves, and trim.
        
        Assembly & Finishing: Individual knitted pieces are expertly linked or sewn together. Buttons are attached, and the garment undergoes a gentle washing and pressing process to achieve its final luxurious feel and shape.
        
        Quality Control: Each sweater is thoroughly inspected to ensure it meets the highest standards of craftsmanship, softness, and finish before being prepared.
`,
      },
    },
  },
  {
    slug: "concrete-gloves",
    name: "Concrete Gloves",
    price: "400",
    category: "accessories",
    description:
      "Indulge in the unparalleled softness and warmth of these cashmere gloves. Crafted from a luxurious, soft woven blend, they offer exceptional comfort and a refined touch to any ensemble. The timeless design and superior material make them a perfect accessory for colder days.",
    material: "100% Cashmere",
    material: "100% Cashmere",
    variants: [
      {
        color: "#332019",
        colorLabel: "Braised Plum",
        size: ["S", "M", "L"],
        image: [GlovesBrown, GlovesBrown2],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Material: Soft Woven Blend
        Color: Brown
        Shape: Classic five-finger glove
        Details: Ribbed cuffs for a secure and comfortable fit
        Texture: Incredibly soft, smooth, and warm
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `
       Hand Wash Recommended: Gently hand wash in cool water (max 30°C / 86°F) using a specialized cashmere or mild wool detergent.
       
       Drying: Gently squeeze out excess water (do not wring). Lay the sweater flat on a clean, dry towel, reshaping it to its original dimensions. Roll the sweater in the towel to absorb more water. Unroll and lay flat on a fresh, dry surface or a mesh drying rack, away from direct sunlight or heat, until completely dry.
       
       Storage: Fold your cashmere sweater neatly and store it in a drawer or on a shelf. Avoid hanging, as this can cause stretching. Use cedar blocks or lavender sachets to deter moths.
       
       Avoid: Harsh detergents, hot water, tumble drying, bleach, and ironing. If pressing is necessary, use a cool iron with a damp cloth between the iron and the sweater.
       `,
      },
      journey: {
        header: "Garment Journey",
        description: `Fleece Sourcing: The journey begins with the careful collection of the finest, softest undercoat fibers from our cashmere goats, from the himalayas.
        
        Sorting & De-hairing: The raw cashmere is sorted by hand to separate the longest, finest fibers, and then de-haired to remove coarser guard hairs.
        
        Washing & Dyeing: The pure cashmere fibers are gently washed to remove impurities, then dyed to achieve the desired colors.

        Knitting: Advanced knitting machines or hand-knitting techniques transform the yarn into the cardigan's soft, coherent fabric, including the body, sleeves, and trim.
        
        Assembly & Finishing: Individual knitted pieces are expertly linked or sewn together. Buttons are attached, and the garment undergoes a gentle washing and pressing process to achieve its final luxurious feel and shape.
        
        Quality Control: Each sweater is thoroughly inspected to ensure it meets the highest standards of craftsmanship, softness, and finish before being prepared.
`,
      },
    },
  },
  {
    slug: "skyvory-beanie",
    name: "Skyvory Beanie",
    price: "400",
    category: "hats",
    description:
      "Elevate your winter wardrobe with this impeccably crafted cashmere ribbed beanie. Designed for both warmth and sophisticated style, this beanie is made from the finest cashmere, offering an incredibly soft touch and comfortable fit. Its classic ribbed design ensures a snug feel, making it an essential accessory for chilly days",
    material: "100% Cashmere",
    variants: [
      {
        color: "#e9e5da",
        colorLabel: "Cream White",
        size: ["S", "M", "L"],
        image: [BeanieWhiteImg, BeanieWhiteImg2],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Material: Luxurious Cashmere
        Color: Cream 
        Shape: Classic beanie with a folded brim
        Details: Ribbed knit construction
        Texture: Exceptionally soft, warm, and comfortable
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `
       Hand Wash Recommended: Gently hand wash in cool water (max 30°C / 86°F) using a specialized cashmere or mild wool detergent.
       
       Drying: Gently squeeze out excess water (do not wring). Lay the sweater flat on a clean, dry towel, reshaping it to its original dimensions. Roll the sweater in the towel to absorb more water. Unroll and lay flat on a fresh, dry surface or a mesh drying rack, away from direct sunlight or heat, until completely dry.
       
       Storage: Fold your cashmere sweater neatly and store it in a drawer or on a shelf. Avoid hanging, as this can cause stretching. Use cedar blocks or lavender sachets to deter moths.
       
       Avoid: Harsh detergents, hot water, tumble drying, bleach, and ironing. If pressing is necessary, use a cool iron with a damp cloth between the iron and the sweater.
       `,
      },
      journey: {
        header: "Garment Journey",
        description: `Fleece Sourcing: The journey begins with the careful collection of the finest, softest undercoat fibers from our cashmere goats, from the himalayas.
        
        Sorting & De-hairing: The raw cashmere is sorted by hand to separate the longest, finest fibers, and then de-haired to remove coarser guard hairs.
        
        Washing & Dyeing: The pure cashmere fibers are gently washed to remove impurities, then dyed to achieve the desired colors.

        Knitting: Advanced knitting machines or hand-knitting techniques transform the yarn into the cardigan's soft, coherent fabric, including the body, sleeves, and trim.
        
        Assembly & Finishing: Individual knitted pieces are expertly linked or sewn together. Buttons are attached, and the garment undergoes a gentle washing and pressing process to achieve its final luxurious feel and shape.
        
        Quality Control: Each sweater is thoroughly inspected to ensure it meets the highest standards of craftsmanship, softness, and finish before being prepared.
`,
      },
    },
  },

  {
    slug: "eigen-beanie",
    name: "Eigen Beanie",
    price: "4,000",
    category: "hats",
    description:
      "Elevate your winter wardrobe with this impeccably crafted cashmere ribbed beanie. Designed for both warmth and sophisticated style, this beanie is made from the finest cashmere, offering an incredibly soft touch and comfortable fit. Its classic ribbed design ensures a snug feel, making it an essential accessory for chilly days",
    material: "100% Cashmere",
    variants: [
      {
        color: "#16161e",
        colorLabel: "Piano Black",
        size: [38, 39, 40, 41, 42, 43, 45],
        image: [BeanieImg, BeanieImg2],
      },
    ],
    cardDetails: {
      details: {
        header: "Details",
        description: `Material: Luxurious Cashmere
        Color: Black 
        Shape: Classic beanie with a folded brim
        Details: Ribbed knit construction
        Texture: Exceptionally soft, warm, and comfortable
        `,
      },
      sizing: {
        header: "Sizing",
        description: `Sizing: Please see the size guide to find your correct size.
       
        Each piece is made in limited quantities as part of our commitment to sustainable and mindful production.`,
      },
      care: {
        header: "Composition & Care",
        description: `
       Hand Wash Recommended: Gently hand wash in cool water (max 30°C / 86°F) using a specialized cashmere or mild wool detergent.
       
       Drying: Gently squeeze out excess water (do not wring). Lay the sweater flat on a clean, dry towel, reshaping it to its original dimensions. Roll the sweater in the towel to absorb more water. Unroll and lay flat on a fresh, dry surface or a mesh drying rack, away from direct sunlight or heat, until completely dry.
       
       Storage: Fold your cashmere sweater neatly and store it in a drawer or on a shelf. Avoid hanging, as this can cause stretching. Use cedar blocks or lavender sachets to deter moths.
       
       Avoid: Harsh detergents, hot water, tumble drying, bleach, and ironing. If pressing is necessary, use a cool iron with a damp cloth between the iron and the sweater.
       `,
      },
      journey: {
        header: "Garment Journey",
        description: `Fleece Sourcing: The journey begins with the careful collection of the finest, softest undercoat fibers from our cashmere goats, from the himalayas.
        
        Sorting & De-hairing: The raw cashmere is sorted by hand to separate the longest, finest fibers, and then de-haired to remove coarser guard hairs.
        
        Washing & Dyeing: The pure cashmere fibers are gently washed to remove impurities, then dyed to achieve the desired colors.

        Knitting: Advanced knitting machines or hand-knitting techniques transform the yarn into the cardigan's soft, coherent fabric, including the body, sleeves, and trim.
        
        Assembly & Finishing: Individual knitted pieces are expertly linked or sewn together. Buttons are attached, and the garment undergoes a gentle washing and pressing process to achieve its final luxurious feel and shape.
        
        Quality Control: Each sweater is thoroughly inspected to ensure it meets the highest standards of craftsmanship, softness, and finish before being prepared.
`,
      },
    },
  },
];

export default products;
